import { compose } from 'recompose';
import TotalTimeItem from './totalTimeItem';

const enhance = compose();
export default enhance(TotalTimeItem);
